import { StrictMode, type ReactNode } from "react";
import { createRoot } from "react-dom/client";
import { IntegrityNotice } from "@/app/ui/IntegrityNotice";
import { LearnerModelDebugPanel } from "@/app/ui/LearnerModelDebugPanel";
import { LabDiscussion } from "@/app/lab/LabDiscussion";
import { logLabEvent } from "@/app/lab/telemetry";
import "@/app/tailwind.css";
import "@/app/globals.css";
import "@/app/chuyenchon-ds.css";

function rootElement() {
  const root = document.getElementById("root");
  if (!root) throw new Error("Missing #root element");
  return root;
}

export function mountPublicPage(page: ReactNode) {
  createRoot(rootElement()).render(<StrictMode>{page}</StrictMode>);
}

export function mountLearnerPage(page: ReactNode) {
  createRoot(rootElement()).render(
    <StrictMode>
      <IntegrityNotice />
      {page}
      <LabDiscussion />
      <LearnerModelDebugPanel />
    </StrictMode>,
  );
  // Log "behaviour chính": mở một lab. Tự no-op ở hub/trang môn/non-lab.
  logLabEvent("lab_open");
}
